export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement4.6043f9b5.png";